<template>
	<div class="flex items-center">
		<div class="bg-white rounded-full w-5 h-5 flex flex-shrink-0 border-2 border-white">
			<input
				:aria-labelledby="id"
				:checked="checked"
				type="radio"
				:name="name"
				class="radioBtn appearance-none rounded-full cursor-pointer w-full h-full checked:border-4 checked:border-secondary hoverEffects"
				@click="clicked" />
		</div>
		<label
			v-if="label"
			:id="id"
			class="ml-2">
			{{ label }}
		</label>
	</div>
</template>

<script setup>
	const { id } = defineProps({
		id: {
			type: String,
		},
		name: {
			type: String,
			default: "radio",
		},
		label: {
			type: String,
			default: "",
		},
		checked: {
			type: Boolean,
			default: false,
		},
	})

	const emits = defineEmits(["clicked"])

	const clicked = (e) => {
		e.preventDefault() //prevent default to let the prop control the checked state
		emits("clicked", { id: id })
	}
</script>

<style lang="scss" scoped></style>
